import { render, staticRenderFns } from "./PlanDiscussion.vue?vue&type=template&id=a99311fa&scoped=true"
import script from "./PlanDiscussion.vue?vue&type=script&lang=js"
export * from "./PlanDiscussion.vue?vue&type=script&lang=js"
import style0 from "./PlanDiscussion.vue?vue&type=style&index=0&id=a99311fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99311fa",
  null
  
)

export default component.exports